module.exports = __webpack_public_path__ + "img/patients-main.2b230f43.webp";